var map = {
	"./bgr-catalog-theme-birthday.svg": "cb7c",
	"./bgr-confetti-2.svg": "fcf5",
	"./bgr-tickling-stars.svg": "46fb",
	"./box-empty-outside.jpg": "96a2",
	"./box-gif-still.png": "90ac",
	"./box-gif.gif": "55d4",
	"./box-packaging-0@1x.png": "7d7c",
	"./box-packaging-0@2x.png": "b8de9",
	"./box.jpg": "06f9",
	"./christmas-page/art-branding.png": "bb57",
	"./christmas-page/art-composer-postcard-alt.png": "62a6",
	"./christmas-page/art-composer-postcard.png": "a8c8",
	"./christmas-page/art-composer-present.png": "a569",
	"./christmas-page/art-composer-shipping.png": "00a3",
	"./christmas-page/art-inhalt.png": "e0ce",
	"./christmas-page/art-lieferung.png": "fc4c",
	"./christmas-page/art-postcard.png": "9137",
	"./christmas-page/autohero-logo.svg": "7727",
	"./christmas-page/bgr-sizzle.png": "03a8",
	"./christmas-page/box-green-opened.png": "00cf",
	"./christmas-page/business-inhalt.png": "c591",
	"./christmas-page/composer-level3.png": "d484",
	"./christmas-page/deco-1.svg": "0562",
	"./christmas-page/deco-2.svg": "0ab8",
	"./christmas-page/deco-3.svg": "aced",
	"./christmas-page/deco-4.svg": "a5df",
	"./christmas-page/hero-img.png": "e761",
	"./christmas-page/icon-easy.svg": "681a",
	"./christmas-page/snow-1.svg": "2a66",
	"./christmas-page/snow-2.svg": "77fb",
	"./christmas-page/snow-3.svg": "fdbd",
	"./christmas-page/snow-4.svg": "24c8",
	"./christmas-page/testimonials-badge.svg": "806a",
	"./christmas-page/testimonials-bgr.svg": "84c0",
	"./christmas-page/testimonials-stars.svg": "6afd",
	"./christmas-page/testimonials-trustpilot-logo.svg": "647b",
	"./christmas-page/trustpilot-badge.svg": "15a0",
	"./christmas-page/tuev-logo.svg": "81a3",
	"./credit-card-logos.svg": "ce28",
	"./custom-present-empty-model.png": "de2f",
	"./custom-present-empty-model@2x.png": "eb20",
	"./customer-landing-page-default@1x.png": "8c05",
	"./customer-landing-page-default@2x.png": "283f",
	"./default-avatar.png": "4294",
	"./demo1.png": "1a31",
	"./demo1@2x.png": "39e9",
	"./empty-box-small.png": "123c",
	"./hero-presents-collage-postcard.png": "b9c9",
	"./hero-presents-collage-postcard@2x.png": "82bf",
	"./hero-presents-collage.png": "0156",
	"./hero-presents-collage@2x.png": "ea1b",
	"./icon-amex.svg": "7c72",
	"./icon-arrow-matrix-overview.svg": "021a",
	"./icon-box-48.svg": "3ca2",
	"./icon-customize-colored.svg": "6413",
	"./icon-delivery-truck-blue.svg": "e863",
	"./icon-gift-colored.svg": "2e21",
	"./icon-lightbulb.svg": "9bea",
	"./icon-mastercard.svg": "9e5a",
	"./icon-paypal.svg": "2d1d",
	"./icon-rechnung.svg": "06dd",
	"./icon-sofort.svg": "ec70",
	"./icon-usp-box.svg": "ba3e",
	"./icon-usp-greeting-card.svg": "bb70",
	"./icon-usp-world.svg": "d4b2",
	"./icon-visa.svg": "93ff",
	"./img-banner-business-presents.png": "b3b6",
	"./img-banner-custom-present.png": "1f1c",
	"./landing-page-lightbulb.svg": "e70b",
	"./landing-page/bgr-blocks.svg": "6b8e",
	"./landing-page/bgr-cardboard-boxes@1x.png": "fe18",
	"./landing-page/bgr-cardboard-boxes@2x.png": "6243",
	"./landing-page/bgr-confetti-yellow.svg": "b705",
	"./landing-page/bgr-confetti.svg": "8b0e",
	"./landing-page/bgr-easter.svg": "f3c3",
	"./landing-page/bgr-sparks.svg": "5d88",
	"./landing-page/bgr-stars.svg": "2e33",
	"./landing-page/bgr-valentine.svg": "8059",
	"./landing-page/box-empty-s-frontal@1x.png": "c336",
	"./landing-page/box-empty-s-frontal@2x.png": "438f",
	"./landing-page/box-packaging@1x.png": "8a5b",
	"./landing-page/box-packaging@2x.png": "8b1d",
	"./landing-page/cursor-big.svg": "68a8",
	"./landing-page/dummyprod-in-motion@1x.png": "e85e",
	"./landing-page/dummyprod-in-motion@2x.png": "6e3c",
	"./landing-page/dummyprod10@1x.png": "1186",
	"./landing-page/dummyprod10@2x.png": "5bb0",
	"./landing-page/dummyprod11@1x.png": "5ef5",
	"./landing-page/dummyprod11@2x.png": "5d4c",
	"./landing-page/dummyprod1@1x.png": "0759",
	"./landing-page/dummyprod1@2x.png": "6776",
	"./landing-page/dummyprod2@1x.png": "2ea6",
	"./landing-page/dummyprod2@2x.png": "9452c",
	"./landing-page/dummyprod3@1x.png": "84186",
	"./landing-page/dummyprod3@2x.png": "1b19",
	"./landing-page/dummyprod4@1x.png": "2809",
	"./landing-page/dummyprod4@2x.png": "f570",
	"./landing-page/dummyprod5@1x.png": "a840",
	"./landing-page/dummyprod5@2x.png": "0103",
	"./landing-page/dummyprod6@1x.png": "2617",
	"./landing-page/dummyprod6@2x.png": "90cd",
	"./landing-page/dummyprod7@1x.png": "6a25",
	"./landing-page/dummyprod7@2x.png": "896a",
	"./landing-page/dummyprod8@1x.png": "86fd",
	"./landing-page/dummyprod8@2x.png": "6f60",
	"./landing-page/dummyprod9@1x.png": "9bee",
	"./landing-page/dummyprod9@2x.png": "6b82",
	"./landing-page/empty-box-s-square.jpg": "7def",
	"./landing-page/flags/abkhazia.svg": "4678",
	"./landing-page/flags/ad.svg": "f4b7",
	"./landing-page/flags/ae.svg": "b4fe",
	"./landing-page/flags/af.svg": "15c3",
	"./landing-page/flags/ag.svg": "fb34",
	"./landing-page/flags/ai.svg": "c595",
	"./landing-page/flags/al.svg": "9452",
	"./landing-page/flags/am.svg": "17a4",
	"./landing-page/flags/ao.svg": "c07a",
	"./landing-page/flags/ar.svg": "125c",
	"./landing-page/flags/as.svg": "5913",
	"./landing-page/flags/at.svg": "6010",
	"./landing-page/flags/au.svg": "302f",
	"./landing-page/flags/aw.svg": "4ec2",
	"./landing-page/flags/ax.svg": "5d29",
	"./landing-page/flags/az.svg": "40ff",
	"./landing-page/flags/azores-islands.svg": "5dfe",
	"./landing-page/flags/ba.svg": "1141",
	"./landing-page/flags/balearic-islands.svg": "0f8f",
	"./landing-page/flags/basque-country.svg": "6094",
	"./landing-page/flags/bb.svg": "a7b3",
	"./landing-page/flags/bd.svg": "8fdd",
	"./landing-page/flags/be.svg": "69f7",
	"./landing-page/flags/bf.svg": "2566",
	"./landing-page/flags/bg.svg": "c215",
	"./landing-page/flags/bh.svg": "950b",
	"./landing-page/flags/bhutan-1.svg": "9d44",
	"./landing-page/flags/bi.svg": "8c75",
	"./landing-page/flags/bl.svg": "796b",
	"./landing-page/flags/bm.svg": "2337",
	"./landing-page/flags/bn.svg": "5a74",
	"./landing-page/flags/bo.svg": "52a1",
	"./landing-page/flags/bonaire.svg": "36a2",
	"./landing-page/flags/br.svg": "2b1e",
	"./landing-page/flags/british-columbia.svg": "15ea",
	"./landing-page/flags/british-indian-ocean-territory.svg": "b5e8",
	"./landing-page/flags/bs.svg": "2fa4d",
	"./landing-page/flags/bt.svg": "5ab8",
	"./landing-page/flags/bw.svg": "c57e",
	"./landing-page/flags/by.svg": "8225",
	"./landing-page/flags/bz.svg": "6a97",
	"./landing-page/flags/ca.svg": "626e",
	"./landing-page/flags/canary-islands.svg": "e912",
	"./landing-page/flags/cc.svg": "7371",
	"./landing-page/flags/ceuta.svg": "1076",
	"./landing-page/flags/cf.svg": "1d49",
	"./landing-page/flags/cg.svg": "fd44",
	"./landing-page/flags/ch.svg": "3c94",
	"./landing-page/flags/ci.svg": "b9c7",
	"./landing-page/flags/ck.svg": "8ab7",
	"./landing-page/flags/cl.svg": "6dcc",
	"./landing-page/flags/cm.svg": "651c",
	"./landing-page/flags/cn.svg": "0d9e",
	"./landing-page/flags/co.svg": "b8de",
	"./landing-page/flags/corsica.svg": "602e",
	"./landing-page/flags/cr.svg": "d887",
	"./landing-page/flags/cu.svg": "66b1",
	"./landing-page/flags/curacao.svg": "639a",
	"./landing-page/flags/cv.svg": "76ed",
	"./landing-page/flags/cx.svg": "1313",
	"./landing-page/flags/cy.svg": "02bc",
	"./landing-page/flags/cz.svg": "3952",
	"./landing-page/flags/de.svg": "31c0",
	"./landing-page/flags/dj.svg": "5fdc",
	"./landing-page/flags/dk.svg": "ffbb",
	"./landing-page/flags/dm.svg": "e007",
	"./landing-page/flags/do.svg": "f36e",
	"./landing-page/flags/dz.svg": "e398",
	"./landing-page/flags/east-timor.svg": "4377",
	"./landing-page/flags/ec.svg": "8458",
	"./landing-page/flags/ee.svg": "eabe",
	"./landing-page/flags/eg.svg": "1f56",
	"./landing-page/flags/eh.svg": "8df3",
	"./landing-page/flags/en.svg": "d15e",
	"./landing-page/flags/er.svg": "be22",
	"./landing-page/flags/es.svg": "5338",
	"./landing-page/flags/et.svg": "4fce",
	"./landing-page/flags/eu.svg": "4562",
	"./landing-page/flags/fi.svg": "9c87",
	"./landing-page/flags/fiji.svg": "5ffa",
	"./landing-page/flags/fk.svg": "6b53",
	"./landing-page/flags/fm.svg": "6ecc",
	"./landing-page/flags/fo.svg": "62f1",
	"./landing-page/flags/fr.svg": "73e5",
	"./landing-page/flags/ga.svg": "8100",
	"./landing-page/flags/galapagos-islands.svg": "7244",
	"./landing-page/flags/gb.svg": "6b93",
	"./landing-page/flags/gd.svg": "0acd",
	"./landing-page/flags/ge.svg": "eb4b",
	"./landing-page/flags/gh.svg": "6b04",
	"./landing-page/flags/gi.svg": "2fe2",
	"./landing-page/flags/gl.svg": "2a33",
	"./landing-page/flags/gm.svg": "d799",
	"./landing-page/flags/gq.svg": "5db1",
	"./landing-page/flags/gr.svg": "0473",
	"./landing-page/flags/gt.svg": "2d5d",
	"./landing-page/flags/gu.svg": "d60b",
	"./landing-page/flags/guernsey.svg": "67e7",
	"./landing-page/flags/guinea.svg": "c8af",
	"./landing-page/flags/gw.svg": "8f3b",
	"./landing-page/flags/gy.svg": "d7ca",
	"./landing-page/flags/hawaii.svg": "c824",
	"./landing-page/flags/hk.svg": "df6f",
	"./landing-page/flags/hn.svg": "9ca6",
	"./landing-page/flags/hr.svg": "ef14",
	"./landing-page/flags/ht.svg": "0628",
	"./landing-page/flags/hu.svg": "e2c4",
	"./landing-page/flags/id.svg": "343b",
	"./landing-page/flags/ie.svg": "130b",
	"./landing-page/flags/il.svg": "c55a",
	"./landing-page/flags/im.svg": "0916",
	"./landing-page/flags/in.svg": "cac5",
	"./landing-page/flags/iq.svg": "a432",
	"./landing-page/flags/ir.svg": "edfe",
	"./landing-page/flags/is.svg": "a554",
	"./landing-page/flags/it.svg": "6523",
	"./landing-page/flags/je.svg": "18a5",
	"./landing-page/flags/jm.svg": "8ad8",
	"./landing-page/flags/jo.svg": "4c73",
	"./landing-page/flags/jp.svg": "d52a",
	"./landing-page/flags/ke.svg": "a9d7",
	"./landing-page/flags/kg.svg": "28c4",
	"./landing-page/flags/kh.svg": "d4ce",
	"./landing-page/flags/kiribati.svg": "ca28",
	"./landing-page/flags/km.svg": "ec0d",
	"./landing-page/flags/kosovo.svg": "92a0",
	"./landing-page/flags/kp.svg": "3c95",
	"./landing-page/flags/kr.svg": "2379",
	"./landing-page/flags/kw.svg": "b6ca",
	"./landing-page/flags/ky.svg": "c491",
	"./landing-page/flags/kz.svg": "f12d",
	"./landing-page/flags/la.svg": "a73a",
	"./landing-page/flags/lb.svg": "f698",
	"./landing-page/flags/lc.svg": "5740",
	"./landing-page/flags/li.svg": "5d2c",
	"./landing-page/flags/lk.svg": "b2c6",
	"./landing-page/flags/lr.svg": "766b",
	"./landing-page/flags/ls.svg": "bb35",
	"./landing-page/flags/lt.svg": "28d8",
	"./landing-page/flags/lu.svg": "3208",
	"./landing-page/flags/lv.svg": "688e",
	"./landing-page/flags/ly.svg": "f751",
	"./landing-page/flags/ma.svg": "be71",
	"./landing-page/flags/madeira.svg": "1daa",
	"./landing-page/flags/mc.svg": "c686",
	"./landing-page/flags/md.svg": "07e5",
	"./landing-page/flags/me.svg": "483c",
	"./landing-page/flags/melilla.svg": "9f8d",
	"./landing-page/flags/mg.svg": "4b73",
	"./landing-page/flags/mh.svg": "3445",
	"./landing-page/flags/ml.svg": "e838",
	"./landing-page/flags/mm.svg": "e79d",
	"./landing-page/flags/mn.svg": "410f",
	"./landing-page/flags/mo.svg": "5190",
	"./landing-page/flags/mp.svg": "2402",
	"./landing-page/flags/mq.svg": "7603",
	"./landing-page/flags/mr.svg": "295f",
	"./landing-page/flags/ms.svg": "f749",
	"./landing-page/flags/mt.svg": "e546",
	"./landing-page/flags/mu.svg": "5322",
	"./landing-page/flags/mv.svg": "afba",
	"./landing-page/flags/mw.svg": "e4f7",
	"./landing-page/flags/mx.svg": "80d1",
	"./landing-page/flags/my.svg": "ee4f",
	"./landing-page/flags/mz.svg": "3542",
	"./landing-page/flags/na.svg": "36fc",
	"./landing-page/flags/nato.svg": "75ef",
	"./landing-page/flags/ni.svg": "d5bd",
	"./landing-page/flags/niger.svg": "34ca",
	"./landing-page/flags/nigeria.svg": "90c6",
	"./landing-page/flags/niue.svg": "0016",
	"./landing-page/flags/nj.svg": "1d90",
	"./landing-page/flags/nl.svg": "8824",
	"./landing-page/flags/no.svg": "babd",
	"./landing-page/flags/norfolk-island.svg": "f411",
	"./landing-page/flags/northen-cyprus.svg": "0da3",
	"./landing-page/flags/np.svg": "3043",
	"./landing-page/flags/nr.svg": "0bdb",
	"./landing-page/flags/nz.svg": "63a8",
	"./landing-page/flags/om.svg": "bdf4",
	"./landing-page/flags/orkney-islands.svg": "10b1",
	"./landing-page/flags/ossetia.svg": "6aaa",
	"./landing-page/flags/pa.svg": "c9bf",
	"./landing-page/flags/pe.svg": "d838",
	"./landing-page/flags/pf.svg": "a9b5",
	"./landing-page/flags/pg.svg": "f5ec",
	"./landing-page/flags/ph.svg": "8f3b9",
	"./landing-page/flags/pk.svg": "c7a8",
	"./landing-page/flags/pl.svg": "df8b",
	"./landing-page/flags/pn.svg": "52d0",
	"./landing-page/flags/pr.svg": "451d",
	"./landing-page/flags/ps.svg": "d2fe",
	"./landing-page/flags/pt.svg": "7c36",
	"./landing-page/flags/pw.svg": "23d4",
	"./landing-page/flags/py.svg": "20a8",
	"./landing-page/flags/qa.svg": "f2e4",
	"./landing-page/flags/rapa-nui.svg": "0831",
	"./landing-page/flags/republic-of-macedonia.svg": "8f42",
	"./landing-page/flags/republic-of-the-congo.svg": "08da",
	"./landing-page/flags/ro.svg": "41f8",
	"./landing-page/flags/rs.svg": "0d82",
	"./landing-page/flags/ru.svg": "8c28",
	"./landing-page/flags/rw.svg": "f833",
	"./landing-page/flags/sa.svg": "8a52",
	"./landing-page/flags/saba-island.svg": "b6d1",
	"./landing-page/flags/saint-kitts-and-nevis.svg": "2462",
	"./landing-page/flags/sb.svg": "0a7e",
	"./landing-page/flags/sc.svg": "2c8a",
	"./landing-page/flags/scotland.svg": "8b8c",
	"./landing-page/flags/sd.svg": "b115",
	"./landing-page/flags/se.svg": "5f84",
	"./landing-page/flags/sg.svg": "faa5",
	"./landing-page/flags/si.svg": "697f",
	"./landing-page/flags/sint-eustatius.svg": "db0a",
	"./landing-page/flags/sk.svg": "d5cc",
	"./landing-page/flags/sl.svg": "60a6",
	"./landing-page/flags/sm.svg": "8ab4",
	"./landing-page/flags/sn.svg": "d629",
	"./landing-page/flags/so.svg": "4283",
	"./landing-page/flags/somaliland.svg": "af16",
	"./landing-page/flags/sr.svg": "1659",
	"./landing-page/flags/ss.svg": "ab77",
	"./landing-page/flags/st.svg": "88fb",
	"./landing-page/flags/sv.svg": "a752",
	"./landing-page/flags/sx.svg": "2735",
	"./landing-page/flags/sy.svg": "8573",
	"./landing-page/flags/sz.svg": "322a",
	"./landing-page/flags/tc.svg": "1b4a",
	"./landing-page/flags/td.svg": "beaf",
	"./landing-page/flags/tg.svg": "4555",
	"./landing-page/flags/th.svg": "509b",
	"./landing-page/flags/tibet.svg": "1cbe",
	"./landing-page/flags/tj.svg": "76cf",
	"./landing-page/flags/tk.svg": "fe26",
	"./landing-page/flags/tm.svg": "0e93",
	"./landing-page/flags/tn.svg": "43be",
	"./landing-page/flags/tokelau.svg": "4527",
	"./landing-page/flags/tr.svg": "2ecb",
	"./landing-page/flags/transnistria.svg": "eb71",
	"./landing-page/flags/tt.svg": "7bca",
	"./landing-page/flags/tv.svg": "21e4",
	"./landing-page/flags/tw.svg": "66c1",
	"./landing-page/flags/tz.svg": "2eb1",
	"./landing-page/flags/ua.svg": "8ac8",
	"./landing-page/flags/ug.svg": "da13",
	"./landing-page/flags/uk.svg": "1a7f",
	"./landing-page/flags/un.svg": "0e3a",
	"./landing-page/flags/us.svg": "1ab6",
	"./landing-page/flags/uy.svg": "cc0f",
	"./landing-page/flags/uz.svg": "36d6",
	"./landing-page/flags/vatican-city.svg": "8a88",
	"./landing-page/flags/vc.svg": "1487",
	"./landing-page/flags/ve.svg": "7aa4",
	"./landing-page/flags/vg.svg": "98ff",
	"./landing-page/flags/vi.svg": "441e",
	"./landing-page/flags/vn.svg": "e165",
	"./landing-page/flags/vu.svg": "b1c0",
	"./landing-page/flags/wales.svg": "6ba7",
	"./landing-page/flags/ws.svg": "eea8",
	"./landing-page/flags/ye.svg": "b878",
	"./landing-page/flags/za.svg": "1959",
	"./landing-page/flags/zm.svg": "0638",
	"./landing-page/flags/zw.svg": "d400",
	"./landing-page/handwrite-seal.svg": "7fe3",
	"./landing-page/handwriting@1x.png": "dde7",
	"./landing-page/handwriting@2x.png": "fd53",
	"./landing-page/handwritten-postcard-full.png": "01e1",
	"./landing-page/handwritten-postcard@1x.jpg": "f4114",
	"./landing-page/handwritten-postcard@2x.jpg": "d387",
	"./landing-page/hero-rounded-bottom.svg": "06b0",
	"./landing-page/icon-box.svg": "87b3",
	"./landing-page/icon-handmade.svg": "d959",
	"./landing-page/icon-shipping-box.svg": "eedd",
	"./landing-page/icon-shipping-combined.svg": "553d",
	"./landing-page/icon-shipping-gift.svg": "87e0",
	"./landing-page/icon-truck.svg": "2978",
	"./landing-page/logo.svg": "5fc5",
	"./landing-page/phone-operator@1x.png": "fbf3",
	"./landing-page/phone-operator@2x.png": "bda4",
	"./landing-page/product-photos/box-packaging-0@1x-min.png": "3265",
	"./landing-page/product-photos/box-packaging-0@1x.png": "eb82",
	"./landing-page/product-photos/box-packaging-0@2x-min.png": "ad33",
	"./landing-page/product-photos/box-packaging-0@2x.png": "0465",
	"./landing-page/star.svg": "9a2b",
	"./logo-b-w.svg": "450b",
	"./logo-dhl.svg": "eaca",
	"./logo-dpd.png": "646d",
	"./logo-dpd.svg": "8722",
	"./logo-ups.svg": "2888",
	"./logo-w.svg": "2fa4",
	"./paper-clip.png": "66cd",
	"./paypal-logo.svg": "2512",
	"./postcard-blank.jpg": "838e",
	"./postcard-motive-placeholder.png": "ce8e",
	"./postcard-onboarding-example@1x.png": "29a3",
	"./postcard-onboarding-example@2x.png": "c407",
	"./promo-fertigen-bgr.svg": "ffb2",
	"./promo-fertigen@1x.png": "ca9b",
	"./promo-fertigen@2x.png": "44e5",
	"./promo-individuelles@1x.png": "46f7",
	"./promo-individuelles@2x.png": "8348",
	"./proposal-page/box-packaging-sm-tmp@1x.png": "1788",
	"./proposal-page/box-packaging-sm-tmp@2x.png": "9819",
	"./proposal-page/box-packaging@1x.png": "e588",
	"./proposal-page/box-packaging@2x.png": "799d",
	"./proposal-page/handwriting@1x.png": "62a2",
	"./proposal-page/handwriting@2x.png": "8f0c",
	"./proposal-page/handwritten-card.png": "fa3c",
	"./proposal-page/schuber.png": "b9b5",
	"./shipping-onboarding-example@1x.png": "2e8e",
	"./shipping-onboarding-example@2x.png": "24ab",
	"./shopping-setup-level1.png": "c2da",
	"./shopping-setup-level3.png": "79d6",
	"./stars.svg": "d1a4",
	"./white-square.svg": "645b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";